/*!
 * FilePondPluginFocalpointEdit 1.6.1
 * Licensed under MIT, https://opensource.org/licenses/MIT/
 * Please visit https://pqina.nl/filepond/ for details.
 */

/* eslint-disable */

(function(global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined'
    ? (module.exports = factory())
    : typeof define === 'function' && define.amd
    ? define(factory)
    : ((global = global || self),
      (global.FilePondPluginFocalpointEdit = factory()));
})(this, function() {
  'use strict';

  /**
   * Focalpoint Plugin
   */

  var plugin = function plugin(fpAPI) {
    var addFilter = fpAPI.addFilter,
      utils = fpAPI.utils,
      views = fpAPI.views;
    var Type = utils.Type,
      createRoute = utils.createRoute;

    // called for each view that is created right after the 'create' method
    addFilter('CREATE_VIEW', function(viewAPI) {
      var is = viewAPI.is,
        view = viewAPI.view,
        query = viewAPI.query;

      // // only hook up to item view
      // if (!is('file')) {
      //   return;
      // }

      var didLoadItem = function didLoadItem(_ref) {
        var root = _ref.root,
          props = _ref.props;
        if (!root.element.classList.contains('filepond--file-wrapper')) return;
        var id = props.id;
        var item = query('GET_ITEM', id);
        if (!item.fileType.includes('image')) {
          return;
        }

        updateFocalPointButton(root, props);
      };

      var updateFocalPointButton = function updateFocalPointButton(
        root,
        props
      ) {
        var focalpointEditor = query('GET_IMAGE_FOCALPOINT_EDITOR');
        var focalpointSet = query('GET_IMAGE_FOCALPOINT_SET');

        var focalpointElement = root.element.querySelectorAll(
          '.filepond--action-focalpoint-item'
        )[0];
        if (focalpointElement) {
          focalpointElement.parentNode.removeChild(focalpointElement);
        }
        focalpointElement = document.createElement('button');
        focalpointElement.className =
          'd-none filepond--action-focalpoint-item filepond--file-action-button';
        focalpointElement.type = 'button';
        focalpointElement.innerHTML =
          '<svg viewBox="0 0 22.9 22.9" xmlns="http://www.w3.org/2000/svg" style="padding: 4px;"><path d="M22.7 11L19 7.5c-.2-.2-.5-.2-.7-.1-.2.1-.4.3-.4.6v1.5h-4.4V5.1H15c.3 0 .5-.2.6-.4.1-.2.1-.5-.1-.7L12 .2c-.2-.1-.3-.2-.5-.2s-.4.1-.5.2L7.5 4c-.2.2-.3.4-.2.7.1.2.3.4.6.4h1.5v4.4H5.1V7.9c0-.3-.2-.5-.4-.6-.3-.1-.5 0-.7.2L.2 11c-.1.1-.2.3-.2.5s.1.4.2.5L4 15.5c.2.2.5.2.7.1.2-.1.4-.3.4-.6v-1.5h4.4v4.4H7.9c-.3 0-.5.2-.6.4-.1.2-.1.5.1.7l3.5 3.7c.1.1.3.2.5.2s.4-.1.5-.2l3.5-3.7c.2-.2.2-.5.1-.7-.1-.2-.3-.4-.6-.4h-1.5v-4.4h4.4V15c0 .3.2.5.4.6.2.1.5.1.7-.1l3.7-3.5c.1-.1.2-.3.2-.5.1-.2.1-.4-.1-.5z" fill="#fff"></path></svg><span>edit</span>';
        root.element.appendChild(focalpointElement);
        setTimeout(function() {
          focalpointElement.classList.remove('d-none');
          // get all the buttons
          var editButton = root.element.querySelectorAll(
            '.filepond--action-edit-item'
          );
          var overlay = root.element.querySelectorAll(
            '.filepond--image-preview-overlay'
          )[0];
          // overlay is in a poster
          if (!overlay) {
            overlay = root.element.querySelectorAll(
              '.filepond--file-poster-overlay'
            )[0];
          }
          var remove = root.element.querySelectorAll(
            '.filepond--action-remove-item'
          )[0];
          var info = root.element.querySelectorAll('.filepond--file-info')[0];

          var x = focalpointSet.x;
          var y = focalpointSet.y;

          var _rect = root.element.querySelectorAll('.filepond--image-clip')[0];
          // image is in a poster
          if (!_rect) {
            _rect = root.element.querySelectorAll('.filepond--file-poster')[0];
          }

          if (!_rect) return;

          var _x =
            (_rect.offsetWidth / 100) * x +
            _rect.offsetLeft -
            focalpointElement.offsetWidth / 2;
          var _y =
            (_rect.offsetHeight / 100) * y +
            _rect.offsetTop -
            focalpointElement.offsetHeight / 2;

          focalpointElement.style.display = 'block';

          var options = {
            grid: 0,
            setCursor: 'move',
            limit: {
              x: [
                _rect.offsetLeft,
                _rect.offsetLeft +
                  _rect.offsetWidth -
                  focalpointElement.offsetWidth
              ],
              y: [0, _rect.offsetHeight - focalpointElement.offsetHeight]
            },

            onDragStart: function onDragStart(element, x, y, event) {
              if (editButton) {
                if (NodeList.prototype.isPrototypeOf(editButton)) {
                  editButton.forEach(function(eb) {
                    eb.style.display = 'none';
                  });
                } else {
                  editButton.style.display = 'none';
                }
              }
              if (remove) remove.style.display = 'none';
              if (overlay) overlay.style.display = 'none';
              if (info) info.style.display = 'none';
            },
            onDragEnd: function onDragEnd(element, x, y, event) {
              if (editButton) {
                if (NodeList.prototype.isPrototypeOf(editButton)) {
                  editButton.forEach(function(eb) {
                    eb.style.display = '';
                  });
                } else {
                  editButton.style.display = '';
                }
              }
              if (remove) remove.style.display = '';
              if (info) info.style.display = '';
              if (overlay) overlay.style.display = '';

              x =
                ((x - _rect.offsetLeft + focalpointElement.offsetWidth / 2) /
                  _rect.offsetWidth) *
                100;
              y =
                ((y - _rect.offsetTop + focalpointElement.offsetHeight / 2) /
                  _rect.offsetHeight) *
                100;
              focalpointEditor.onDragEnd({ x: x, y: y });
            }
          };

          root.ref.focalpontItem = new Draggable(focalpointElement, options);
          root.ref.focalpontItem.set(_x, _y);
        }, 1000);
      };

      // start writing
      view.registerWriter(
        createRoute(
          {
            DID_LOAD_ITEM: didLoadItem,
            DID_COMPLETE_ITEM_PROCESSING: didLoadItem
          },
          function(_ref2) {
            var root = _ref2.root,
              props = _ref2.props;
            var id = props.id;
            var item = query('GET_ITEM', id);

            // don't do anything while not an video or audio file or hidden
            // if (!item || (!isPreviewableVideo(item.file) && !isPreviewableAudio(item.file)) || root.rect.element.hidden) return;
          }
        )
      );
    });

    // Expose plugin options
    return {
      options: {
        // enable or disable image editing
        allowImageFocalpointEdit: [true, Type.BOOLEAN],

        // open editor when image is dropped
        imageFocalpointInstantEdit: [false, Type.BOOLEAN],

        // focalpoint starting point
        imageFocalpointSet: [
          {
            x: 50,
            y: 50
          },
          Type.OBJECT
        ],

        // the icon to use for the edit button
        imageFocalpointIconEdit: [
          '<svg width="26" height="26" viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M8.5 17h1.586l7-7L15.5 8.414l-7 7V17zm-1.707-2.707l8-8a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-8 8A1 1 0 0 1 10.5 19h-3a1 1 0 0 1-1-1v-3a1 1 0 0 1 .293-.707z" fill="currentColor" fill-rule="nonzero"/></svg>',
          Type.STRING
        ],

        // editor object
        imageFocalpointEditor: [null, Type.OBJECT]
      }
    };
  };

  // fire pluginloaded event if running in browser, this allows registering the plugin when using async script tags
  var isBrowser =
    typeof window !== 'undefined' && typeof window.document !== 'undefined';
  if (isBrowser) {
    document.dispatchEvent(
      new CustomEvent('FilePond:pluginloaded', { detail: plugin })
    );
  }

  return plugin;
});
